import { createWebHistory, createRouter } from 'vue-router'

import useUser from '@/composables/user'

import NotFound from '@/pages/NotFound.vue'
import Guest from '@/layouts/Guest.vue'
import Login from '@/pages/auth/Login.vue'
import Authenticated from '@/layouts/Authenticated.vue'
import Welcome from '@/pages/Welcome.vue'
import Logout from '@/pages/auth/Logout.vue'
// import Dashboard from "../components/admin/Dashboard.vue";
import Users from '../components/admin/Users.vue'
import Suppliers from '../components/admin/Suppliers.vue'
import Categories from '../components/admin/Categories.vue'
import Products from '../components/admin/Products.vue'
import ProductCreate from '../components/admin/ProductCreate.vue'
import ProductEdit from '../components/admin/ProductEdit.vue'
import Orders from '@/pages/Orders.vue'
import Payments from '@/pages/Payments.vue'
import Order from '@/pages/Order.vue'
import Profile from '@/pages/Profile.vue'
import Tags from '@/pages/Tags.vue'
import Tag from '@/pages/Tag.vue'
import Logs from '@/pages/Logs.vue'
import LogDetails from '@/pages/LogDetails.vue'
import Services from '@/pages/Services'
import Banners from '@/pages/Banners'
import Banner from '@/pages/Banner'

const { loggedIn } = useUser()

const routes = [
    {
        path: '/',
        component: Authenticated,
        meta: { requiresAuth: true },
        children: [
            { path: '/', name: 'welcome', component: Welcome },
            { path: '/logout', name: 'logout', component: Logout },
            // { path: '/admin/dashboard', name: 'dashboard', component: Dashboard },
            { path: '/admin/users', name: 'users', component: Users },
            {
                path: '/admin/suppliers',
                name: 'suppliers',
                component: Suppliers,
            },
            {
                path: '/admin/categories',
                name: 'categories',
                component: Categories,
            },
            { path: '/admin/products', name: 'products', component: Products },
            {
                path: '/admin/products/create',
                name: 'productCreate',
                component: ProductCreate,
            },
            {
                path: '/admin/products/:id',
                name: 'productEdit',
                component: ProductEdit,
            },
            { path: '/admin/payments', name: 'Payments', component: Payments },
            { path: '/admin/orders', name: 'Orders', component: Orders },
            { path: '/admin/orders/:id', name: 'Order', component: Order },
            { path: '/admin/profile', name: 'Profile', component: Profile },
            { path: '/admin/tags', name: 'Tags', component: Tags },
            { path: '/admin/tags/:id', name: 'Tag', component: Tag },
            { path: '/admin/logs', name: 'Logs', component: Logs },
            { path: '/admin/logs/:id', name: 'Log', component: LogDetails },
            {
                path: '/admin/profile',
                name: 'AdminProfile',
                component: Profile,
            },
            {
                path: '/admin/services',
                name: 'AdminService',
                component: Services,
            },
            {
                path: '/admin/banners',
                name: 'AdminBanners',
                component: Banners,
            },
            {
                path: '/admin/banners/:id',
                name: 'AdminBanner',
                component: Banner,
            },
        ],
    },
    {
        path: '/supplier',
        component: Authenticated,
        meta: { requiresAuth: true },
        children: [
            { path: '/', name: 'supplierWelcome', component: Welcome },
            {
                path: 'categories',
                name: 'supplierCategories',
                component: Categories,
            },
            { path: 'products', name: 'supplierproducts', component: Products },
            {
                path: 'products/create',
                name: 'supplierproductCreate',
                component: ProductCreate,
            },
            {
                path: 'products/:id',
                name: 'supplierproductEdit',
                component: ProductEdit,
            },
            { path: '/profile', name: 'Profile', component: Profile },
            {
                path: 'orders',
                name: 'supplierOrders',
                component: Products,
            },
            {
                path: 'profile',
                name: 'supplierProfile',
                component: Profile,
            }
        ],
    },
    {
        path: '/client',
        component: Authenticated,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'orders',
                name: 'clientOrders',
                component: Orders,
            },
            {
                path: 'profile',
                name: 'clientProfile',
                component: Profile,
            },
        ],
    },
    {
        path: '/auth',
        redirect: '/login',
        component: Guest,
        meta: { isGuest: true },
        children: [{ path: '/login', name: 'login', component: Login }],
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: NotFound,
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !loggedIn()) {
        next({ name: 'login' })
    } else if (to.meta.isGuest && loggedIn()) {
        next({ name: 'welcome' })
    } else {
        next()
    }
})

export default router
